module.exports = __webpack_public_path__ + "static/img/shop1.a6fd41d7.png";